import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../Common/Messages';
import DocFav from '../Common/DocFav';
import PopUp from '../Common/PopUp';

const MyBookmarks = (props) => {
    const navigate = useNavigate();
    const [folderList, setFolderList] = useState([]);
    const [folderItemList, setFolderItemList] = useState([]);
    const [selectedFolderSeq, setSelectedFolderSeq] = useState([]);
    const [selectedFolderName, setSelectedFolderName] = useState('');
    const [filteredFolderItems, setFilteredFolderItems] = useState([]);
    const [popupContent, setPopUpContent] = useState(null);

    useEffect(() => {
        getFavoriteManualFolder();
    }, []);

    useEffect(() => {
        const folder = folderList.find(folder => folder.folderSeq === selectedFolderSeq);
        if (folder) {
            setSelectedFolderName(folder.folderName);
        }
    }, [selectedFolderSeq, folderList]);

    useEffect(() => {
        const items = folderItemList.filter(item => item.folderSeq === selectedFolderSeq);
        setFilteredFolderItems(items);
    }, [folderItemList, selectedFolderSeq]);

    const handleFolderClick = (folderSeq) => {
        setSelectedFolderSeq(folderSeq);
    };

    const handleDeleteFolder = (folderItemSeq) => {
        const body = {
            workingTag: 'D',
            devUserId: props.userId,
            folderSeq: selectedFolderSeq,
            folderItemSeq: folderItemSeq,
            manualId: ''
        };
        fetch(`api/Document/SaveFavoriteManualFolderItem`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                if (resultData.message === 'Success') {
                    setFolderItemList((prevList) => {
                        return prevList.filter(item => item.folderSeq !== selectedFolderSeq || item.folderItemSeq !== folderItemSeq);
                    });
                }
                else {
                    showToast('danger', '저장 실패');
                }
            });
    };

    const btnOnPopup = (e, type) => {
        if (e !== undefined) {
            e.stopPropagation();
        }
        if (type === '') {
            setPopUpContent(
                <DocFav
                    onClose={setPopUpContent}
                    folderList={folderList}
                    folderItemList={props.folderItemList}
                    setFolderList={setFolderList}
                    setFolderItemList={props.setFolderItemList}
                    userId={props.userId}
                    manualId={props.manualId}
                    locationFrom={'account'}
                />
            );
        } else {
            setPopUpContent(null);
        }
    }

    const getFavoriteManualFolder = () => {
        if (props.userId === '') return;
        const body = {
            devUserId: props.userId
        };
        fetch(`api/Document/GetFavoriteManualFolder`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                setFolderList(resultData.data.table);
                setFolderItemList(resultData.data.table1);
                if (resultData.data.table.length > 0) {
                    setSelectedFolderSeq(resultData.data.table[0].folderSeq)
                }
            });
    };

    const BookmarkItem = ({ folderItemSeq, title, linkPath, navigate, pathSegments }) => {
        const [isBookmarked, setIsBookmarked] = useState(true);

        const toggleIconClass = (e) => {
            e.stopPropagation();
            if (isBookmarked) {
                const confirmRemoval = window.confirm("즐겨찾기에서 제거하시겠습니까?");
                if (!confirmRemoval) return;
                setIsBookmarked(!isBookmarked);
                handleDeleteFolder(folderItemSeq)
            }
        };

        return (
            <li className="bmrk-list-each" onClick={() => navigate(linkPath)}>
                <button className="bmrk-btn" onClick={toggleIconClass}>
                    <i className={`icoKdc16 ${isBookmarked ? "star-b" : "star-g"}`}></i>
                </button>
                <div className="doc-info">
                    <div className="doc-path">
                        {pathSegments.map((segment, index) => (
                            <React.Fragment key={index}>
                                <span className="doc-path-text">{segment}</span>
                                {index < pathSegments.length - 1 && (
                                    <i className="icoKdc12 next"></i>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                    <p className="doc-title">{title}</p>
                </div>
            </li>
        );
    };

    return (
        <div className="myinfo-cnts">
            <h3 className='myinfo-cnts-title'>즐겨찾기한 매뉴얼</h3>
            <div className="myinfo-cnts-wrap">
                <div className="bmrkfolder-list-wrap">
                    <ul className="bmrkfolder-list">
                        {folderList.map((folder) => (
                            <li
                                key={folder.folderSeq}
                                className={selectedFolderSeq === folder.folderSeq ? 'selected' : ''}
                                onClick={() => handleFolderClick(folder.folderSeq)}
                            >
                                <i className="icoKdc24 bmrkfolder"></i>
                                <span className="bmrkfolder-name">{folder.folderName}</span>
                            </li>
                        ))}
                    </ul>
                    <button className='btn-bmrk-setting' onClick={(e) => btnOnPopup(e, '') }>
                        <i className='icoKdc20 setting-s'></i>
                        설정
                    </button>
                </div>
                {selectedFolderName &&
                    <div className="bmrk-list-wrap">
                        <div className="bmrk-title">
                            <i className="icoKdc24 bmrkfolder"></i>
                            <p>{selectedFolderName}</p>
                        </div>
                        <div className="bmrk-cnts">
                            {!(filteredFolderItems.length === 1 && filteredFolderItems[0].folderItemSeq === 0) && filteredFolderItems.length !== 0 ?
                                <ul className="bmrk-list-wrap">
                                    {filteredFolderItems.map((item) => {
                                        const pathSegments = JSON.parse(item.fullPath || []);

                                        return (
                                            <BookmarkItem
                                                key={item.folderItemSeq}
                                                folderItemSeq={item.folderItemSeq}
                                                title={item.title}
                                                linkPath={item.linkPath}
                                                navigate={navigate}
                                                pathSegments={pathSegments}
                                            />
                                        );
                                    })}
                                </ul>
                                :
                                <div className='bmrk-empty'>
                                    <i className='icoKdc80 empty'></i>
                                    <span>즐겨찾기한 내역이 없습니다.</span>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
            <PopUp content={popupContent} setContent={setPopUpContent} />
        </div>
    );
}
export default MyBookmarks;